<template>
  <div id="app">
    <router-link to="/"></router-link>
    <router-view
      :key="$router.currentRoute.fullPath"
      v-if="routerState"
    ></router-view>
  </div>
</template>

<style lang="scss"></style>

<script>
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      routerState: true,
    };
  },
  watch: {
    '$i18n.locale': {
      handler(val) {
        document.documentElement.setAttribute('lang', val);
      },
      immediate: true,
    },
  },
  methods: {
    reload() {
      this.routerState = false;
      this.$nextTick(() => {
        this.routerState = true;
      });
    },
  },
};
</script>
<style>
div {
  cursor: default;
}
.kongbai {
  width: 100%;
  height: 50px;
  background: #f5f5f5;
}
</style>
